import { Button, Flex, Image, LocalVideo, RemoteVideo } from '../2022-component-library';
import { Icon } from '../component-library';
import { Navigation } from '.';
import { useVideo } from '../context/videoContext';
import ibisLogo from '../assets/img/rebrand-logo.svg';
import styled from '@emotion/styled';
import DenseNavigation from './DenseNavigation';
import { useBreakpoints } from '../helpers/useBreakpoints';
import { useNotes } from '../context/notesContext';
import { calibrationConstants } from '../helpers/calibration-constants';

const VideoContainer = styled(Flex)`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: ${({ lg }) => (lg ? '240px' : '200px')};
  height: ${({ lg }) => (lg ? '160px' : '120px')};
  border-radius: ${calibrationConstants.VIDEO_BORDER_RADIUS}px;
  box-shadow: 0px 11px 22px #b9d5d5;
  position: relative;
  color: #fff;
  background-color: ${({ hidden }) => (hidden ? 'rgba(0, 0, 0, 0.5)' : '#fff')};
`;

const VideoRefreshOverlay = styled(Flex)`
  background-color: rgba(0, 0, 0, 0.2);
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin: 10px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  justify-content: center;
  align-items: center;

  &:hover {
    background-color: rgba(0, 0, 0, 0.3);
    cursor: pointer;
  }

  & svg {
    display: block !important;
  }
`;

const SidePanel = ({ activeTab, setActiveTab }) => {
  const { sm, lg, breakpoints } = useBreakpoints();
  const { reconnect } = useVideo();
  const { showNotes, toggleNotes } = useNotes();

  const refreshVideo = () => reconnect();

  return (
    <Flex
      id='side-panel-container'
      column
      width={breakpoints('15vw', '250px', '320px')}
      minWidth='75px'
      height='100dvh'
      backgroundColor='#fff'
      boxShadow='0px 11px 22px #B9D5D5'
      position='fixed'
      overflow='auto'
      gap='1rem'
    >
      <Flex id='video-and-nav-container' column alignItems='center' flex='1' paddingTop={`${lg ? '1.25rem' : '0.75rem'}`} gap={lg ? '2rem' : '1rem'}>
        {!sm && (
          <Flex column alignItems='center'>
            <VideoContainer marginBottom='1rem' lg={lg}>
              <VideoRefreshOverlay onClick={() => refreshVideo()}>
                <Icon icon='loop2' size={15} color='white' />
              </VideoRefreshOverlay>
              <LocalVideo />
            </VideoContainer>
            <VideoContainer
              lg={lg}
              marginBottom='1.25rem'
              hidden={activeTab === 'consultationView'}
              style={{ zIndex: activeTab === 'consultationView' ? '-1' : '1' }}
            >
              <RemoteVideo />
            </VideoContainer>
            <Button fontFamily='Plus Jakarta Sans' onClick={() => toggleNotes()}>
              {`${showNotes ? 'Hide' : 'Show'} Notes`}
            </Button>
          </Flex>
        )}
        {sm ? (
          <DenseNavigation activeTab={activeTab} setActiveTab={setActiveTab} />
        ) : (
          <Navigation activeTab={activeTab} setActiveTab={setActiveTab} />
        )}
      </Flex>
      <Flex id='logo-container' width='100%' justifyContent='center' paddingBottom='0.5rem'>
        <Image src={ibisLogo} alt='ibisvision logo' width={sm ? '80px' : '100px'} />
      </Flex>
    </Flex>
  );
};

export default SidePanel;
